const THIRTY_DAYS_SEC = 30 * 24 * 60 * 60;

function isPwaEnv(): boolean {
    const standaloneDisplayMode = window.matchMedia?.("(display-mode: standalone)")?.matches === true;
    const iosStandalone = (window.navigator as any)?.standalone === true;
    
    return standaloneDisplayMode || iosStandalone;
}

function setPwaCookie(): void {
    try {
        const secureAttr = window.location.protocol === "https:" ? "; Secure" : "";
        // eslint-disable-next-line @microsoft/sdl/no-cookies -- (https://aka.ms/OWALintWiki) Standard way to read the cookie that is safe across workers
        document.cookie = `isPwa=true; Path=/; SameSite=Lax; Max-Age=${THIRTY_DAYS_SEC}${secureAttr}`;
    }
    catch { }
}

export default function trySetPwaCookie(): void {
    if (typeof window === "undefined") {
        return;
    }
    
    if (!isPwaEnv()) {
        return;
    }
    
    if (window.location.host.indexOf("office.com") === -1) {
        return;
    }
    
    const cookieAlreadySet = 
    // eslint-disable-next-line @microsoft/sdl/no-cookies -- (https://aka.ms/OWALintWiki) Standard way to read the cookie that is safe across workers
    typeof document !== "undefined" && document.cookie.includes("isPwa=true");
    
    if (!cookieAlreadySet) {
        setPwaCookie();
    }
}
